import { render, staticRenderFns } from "./TickOrCross.vue?vue&type=template&id=3406a5aa&scoped=true"
import script from "./TickOrCross.vue?vue&type=script&lang=ts"
export * from "./TickOrCross.vue?vue&type=script&lang=ts"
import style0 from "./TickOrCross.vue?vue&type=style&index=0&id=3406a5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3406a5aa",
  null
  
)

export default component.exports